import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import shallow from 'zustand/shallow';

import AddAGuarantor from '../../components/UploadDocuments/AddAGuarantor';
import AddAnotherGuarantorOrFinish from '../../components/UploadDocuments/AddAnotherGuarantorOrFinish';
import UploadGuarantorDocuments from '../../components/UploadDocuments/UploadGuarantorDocuments';
import VerifyIdentity from '../../components/UploadDocuments/VerifyIdentity';
import WaitForConfirmation from '../../components/UploadDocuments/WaitForConfirmation';
import { UPLOAD_DOCUMENTS_FLOW_STEPS } from '../../shared/constants';
import { areUserIdentityDocumentsUploaded } from '../../shared/helpers/';
import useBookingGuarantors from '../../shared/hooks/useBookingGuarantors';
import useUserDocuments from '../../shared/hooks/useUserDocuments';
import useStore from '../../store';

const UploadDocumentsSteps = (): JSX.Element => {
  const { t } = useTranslation(['routes', 'form']);

  const navigate = useNavigate();
  const { step, locale } = useParams();
  const [searchParams] = useSearchParams();

  const bookingId = searchParams.get('booking_id');
  const isLoadingGuarantors = useBookingGuarantors(bookingId);

  const { user, userDocuments } = useStore(
    state => ({
      user: state.user,
      userDocuments: state.userDocuments,
    }),
    shallow,
  );
  const isLoadingUserDocuments = useUserDocuments(user?.id ?? null);

  const isIdentityVerified = areUserIdentityDocumentsUploaded(userDocuments);

  //step validator
  useEffect(() => {
    if (!isLoadingUserDocuments) {
      if (
        step === UPLOAD_DOCUMENTS_FLOW_STEPS.VERIFY_IDENTITY &&
        isIdentityVerified
      )
        navigate(
          `/${locale}/${t('routes:uploadDocuments')}/${
            UPLOAD_DOCUMENTS_FLOW_STEPS.ADD_A_GUARANTOR
          }?booking_id=${bookingId}`,
          {
            replace: true,
          },
        );
      else if (
        step !== UPLOAD_DOCUMENTS_FLOW_STEPS.VERIFY_IDENTITY &&
        !isIdentityVerified
      )
        navigate(
          `/${locale}/${t('routes:uploadDocuments')}/${
            UPLOAD_DOCUMENTS_FLOW_STEPS.VERIFY_IDENTITY
          }?booking_id=${bookingId}`,
          {
            replace: true,
          },
        );
    }
  }, [isLoadingUserDocuments]);

  return (
    <>
      {!isLoadingGuarantors && (
        <>
          {step === UPLOAD_DOCUMENTS_FLOW_STEPS.VERIFY_IDENTITY && (
            <VerifyIdentity />
          )}
          {step === UPLOAD_DOCUMENTS_FLOW_STEPS.ADD_A_GUARANTOR && (
            <AddAGuarantor />
          )}
          {step === UPLOAD_DOCUMENTS_FLOW_STEPS.UPLOAD_GUARANTOR_DOCUMENTS && (
            <UploadGuarantorDocuments />
          )}
          {step ===
            UPLOAD_DOCUMENTS_FLOW_STEPS.ADD_ANOTHER_GUARANTOR_OR_FINISH && (
            <AddAnotherGuarantorOrFinish />
          )}
          {step === UPLOAD_DOCUMENTS_FLOW_STEPS.WAIT_FOR_CONFIRMATION && (
            <WaitForConfirmation />
          )}
        </>
      )}
    </>
  );
};

export default UploadDocumentsSteps;
